import styled from 'styled-components'

const StyledUserIcons = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin-bottom: 70px;
  margin-top: 20px;

  .user-bubble {
    height: 42px;
    width: 42px;
    border-radius: 21px;
    border: 3px solid white;
  }

  .first-img {
    position: absolute;
  }

  .second-img {
    position: absolute;
    left: 25px;
  }

  .third-img {
    position: absolute;
    left: 46px;
  }

  .fourth-img {
    position: absolute;
    left: 67px;
  }

  .cta {
    position: absolute;
    left: 105px;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.gray[600]};
    display: inline-block;
    margin-left: 14px;
    max-width: 250px;
  }
`

export default StyledUserIcons
